<div class="app">
  <div class="app__inner" [class.anim--in]="loading()">
    @if (loaded()) {
      <fstr-cookie-notice
        [title]="'cookiemelding:cookie-titel' | fromDictionary"
        [text]="'cookiemelding:cookie-tekst' | fromDictionary"
        [buttonAccept]="'cookiemelding:cookie-accepteer-knop-tekst' | fromDictionary"
        [buttonReject]="'cookiemelding:cookie-afwijzen-knop-tekst' | fromDictionary"
      ></fstr-cookie-notice>
    }

    @if (loaded()) {
      <app-topbar
        (toggleOverlay)="toggleMenu()"
        (closeOverlay)="closeMenu()"
        (openOverlay)="openMenu()"
        [menuActive]="menuOpen()"
        [menu]="('main-menu' | fromMenu)?.error ? [] : ('main-menu' | fromMenu)"
        [theme]="menuTheme()"
      ></app-topbar>
    }

    <div class="app__router">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>

    @if (loaded()) {
      <app-footer
        [domain]="domainName"
        [socials]="socialChannels()"
        [memberships]="memberships()"
        [menu]="'footer-menu' | fromMenu"
      ></app-footer>
    }
  </div>

  <app-loader-indicator [loading]="loading()"></app-loader-indicator>
</div>

@if (testGridEnabled) {
  <app-grid-overlay></app-grid-overlay>
}
